import { render, staticRenderFns } from "./MenuTitle.html?vue&type=template&id=5064e180&external"
import script from "./MenuTitle.vue?vue&type=script&lang=js"
export * from "./MenuTitle.vue?vue&type=script&lang=js"
import style0 from "./MenuTitle.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports